import React from 'react';

type Props = {
  children: number;
};

export default function Thousands({ children }: Props) {
  if (!children) {
    return null;
  }

  let value = children | 0;

  if (value < 1000) {
    return <>{`< 1 t`}</>;
  } else return <>{`${Math.round(value / 1000)} t`}</>;
}
